import ReportApi from "../../restapi/reportApi";
import { globalDexieDb } from "../DexiedbLib";
import { ContactsConfig, IContactsConfig } from "../model/contactConfig";
import { KetQuaKey, KetQuaStruct, SoCuocKey } from "../model/ketQuaTrung";
import { IKetQua } from "../model/ketqua";
import { IMessageDetail } from "../model/messageDetails";

const Giai_6Lo_MN: string[] = ["6.1", "6.2", "6.3", "5.1", "4.1", "0.1"];
const Giai_7Lo_MN_3C: string[] = ["7.1", "6.1", "6.2", "6.3", "5.1", "4.1", "0.1"];
const Giai_7Lo_MN_2C: string[] = ["7.1", "6.1", "6.2", "6.3", "5.1", "8.1", "0.1"];
const Giai_8Lo_MB_2C: string[] = ["7.1", "7.2", "7.3", "7.4", "6.1", "6.2", "6.3", "0.1"];
const Giai_6Lo_MB_2C: string[] = ["7.1", "7.2", "7.3", "7.4", "6.3", "0.1"];
const Giai_6Lo_MB_3C: string[] = ["6.1", "6.2", "6.3", "5.5", "5.6", "0.1"];


const Giai_Dau2C_HN: string[] = ["7.1", "7.2", "7.3", "7.4"];
const Giai_Dau2C_MN: string[] = ["8.1"];

const Giai_Dau4C_HN: string[] = ["5.1", "5.2", "5.3", "5.4", "5.5", "5.6"];
const Giai_Dau4C_MN: string[] = ["6.1", "6.2", "6.3"];

const Giai_XC_Dau_HN: string[] = ["6.1", "6.2", "6.3"];
const Giai_XC_Dau_MN: string[] = ["7.1"];

const Giai_XC_HN: string[] = ["6.1", "6.2", "6.3", "0.1"];
const Giai_XC_MN: string[] = ["7.1", "0.1"];

const Giai_Duoi2C_All: string[] = ["0.1"];
const Giai_XC_DUOI_All: string[] = ["0.1"];

// Northern region syntax
const Giai_Nhat_HN: string[] = ["1.1"];
const Giai_Nhi_HN: string[] = ["2.1"];

const CacLoaiDaXien: string[] = ["DaT", "DaX", "Xi2", "Xi3", "Xi4", "Xi2A", "Xi3A", "Xi4A"];
const redis: Map<string, KetQuaKey> = new Map();
async function InsertRedis(key: KetQuaKey): Promise<void> {
    const db = globalDexieDb
    //const found = await db.ketQuaTrung.where("[area+loaicuoc+socuoc+ngay]")
    //    .equals([key.area, key.loaicuoc, key.socuoc, key.ngay]).first()

    const keyRedis = `${key.area}+${key.loaicuoc}+${key.socuoc}+${key.ngay}`
    let found = redis.get(keyRedis)
    if (found) {
        found.sonhay += 1;
        // Bắt đầu một transaction
        //await db.transaction('rw', db.ketQuaTrung, async () => {
        // Thực hiện PUT vào bảng
        //await db.ketQuaTrung.put(found);

        //});
    } else {
        key.sonhay = 1;
        // Bắt đầu một transaction
        //await db.transaction('rw', db.ketQuaTrung, async () => {
        // Thực hiện PUT vào bảng
        //await db.ketQuaTrung.put(key);
        //});
        redis.set(keyRedis, key)
    }
}
/** 6Lo 3 con MB CHƯA CONVERT */
async function Insert_6Lo2C_6Lo3C_MB(ketqua: KetQuaStruct): Promise<void> {
    if (ketqua.area !== "HN") {
        return;
    }
    const ok1: boolean = Giai_6Lo_MB_2C.includes(ketqua.tengiai);
    const ok2: boolean = Giai_6Lo_MB_3C.includes(ketqua.tengiai);
    if (!ok1 && !ok2) {
        return;
    }

    if (ketqua.sodaydu.length < 3) {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const start2C: number = length - 2;
    const start3C: number = length - 3;
    const end: number = length;
    const key2c: KetQuaKey = { area: ketqua.area, loaicuoc: "6Lo2C", socuoc: ketqua.sodaydu.slice(start2C, end), ngay: ketqua.ngay.slice(0, 10), sonhay: 0 };
    InsertRedis(key2c);
    const key3c: KetQuaKey = { area: ketqua.area, loaicuoc: "6Lo3C", socuoc: ketqua.sodaydu.slice(start3C, end), ngay: ketqua.ngay.slice(0, 10), sonhay: 0 };
    InsertRedis(key3c);
}

async function Insert_6Lo2C_6Lo3C(ketqua: KetQuaStruct) {
    if (!Giai_6Lo_MN.includes(ketqua.tengiai)) {
        return;
    }
    if (ketqua.area === "HN") {
        return;
    }
    if (ketqua.sodaydu.length < 3) {
        return;
    }
    const length = ketqua.sodaydu.length;
    const start2C = length - 2;
    const start3C = length - 3;
    const end = length;
    const key2c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "6Lo2C",
        socuoc: ketqua.sodaydu.substring(start2C, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0,
    };
    await InsertRedis(key2c);
    const key3c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "6Lo3C",
        socuoc: ketqua.sodaydu.substring(start3C, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0,
    };
    await InsertRedis(key3c);
}
// 7Lo 2C
async function Insert_7Lo2C(ketqua: KetQuaStruct) {
    if (!Giai_7Lo_MN_2C.includes(ketqua.tengiai)) {
        return;
    }
    if (ketqua.area === "HN") {
        return;
    }
    if (ketqua.sodaydu.length < 2) {
        return;
    }
    const length = ketqua.sodaydu.length;
    const start2C = length - 2;

    const end = length;
    const key2c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "7Lo2C",
        socuoc: ketqua.sodaydu.substring(start2C, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0,
    };
    await InsertRedis(key2c);
}
async function Insert_7Lo3C(ketqua: KetQuaStruct) {
    if (!Giai_7Lo_MN_3C.includes(ketqua.tengiai)) {
        return;
    }
    if (ketqua.area === "HN") {
        return;
    }
    if (ketqua.sodaydu.length < 3) {
        return;
    }
    const length: number = ketqua.sodaydu.length;

    const start3C: number = length - 3;
    const end: number = length;

    const key3c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "7Lo3C",
        socuoc: ketqua.sodaydu.substring(start3C, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0,
    };
    await InsertRedis(key3c);
}
async function Insert_8Lo2C(ketqua: KetQuaStruct) {
    if (!Giai_8Lo_MB_2C.includes(ketqua.tengiai)) {
        return;
    }
    if (ketqua.area !== "HN") {
        return;
    }
    if (ketqua.sodaydu.length < 2) {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const start2C: number = length - 2;
    const end: number = length;
    const key2c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "8Lo2C",
        socuoc: ketqua.sodaydu.substring(start2C, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0,
    };
    await InsertRedis(key2c);
}
// Dau2C
async function Insert_Dau_2C(ketqua: KetQuaStruct) {
    if (!(Giai_Dau2C_HN.includes(ketqua.tengiai) ||
        Giai_Dau2C_MN.includes(ketqua.tengiai))) {
        return;
    }
    if (ketqua.sodaydu.length < 2) {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const start2C: number = length - 2;
    const end: number = length;
    if (ketqua.area === "HN") {
        if (Giai_Dau2C_HN.includes(ketqua.tengiai)) {
            const key2c: KetQuaKey = {
                area: ketqua.area,
                loaicuoc: "Dau2C",
                socuoc: ketqua.sodaydu.slice(start2C, end),
                ngay: ketqua.ngay.slice(0, 10),
                sonhay: 0,
            };
            await InsertRedis(key2c);
        }
    } else if (Giai_Dau2C_MN.includes(ketqua.tengiai)) {
        const key2c: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Dau2C",
            socuoc: ketqua.sodaydu.slice(start2C, end),
            ngay: ketqua.ngay.slice(0, 10),
            sonhay: 0,
        };
        await InsertRedis(key2c);
    }
}
// Dau4C
async function Insert_Dau_4C(ketqua: KetQuaStruct) {
    if (ketqua.sodaydu.length < 4) {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const start2C: number = length - 4;
    const end: number = length;
    if (ketqua.area === "HN") {
        if (Giai_Dau4C_HN.includes(ketqua.tengiai)) {
            const key2c: KetQuaKey = {
                area: ketqua.area,
                loaicuoc: "Dau4C",
                socuoc: ketqua.sodaydu.substring(start2C, end),
                ngay: ketqua.ngay.substring(0, 10),
                sonhay: 0,
            };
            await InsertRedis(key2c);
        }
    } else if (Giai_Dau4C_MN.includes(ketqua.tengiai)) {
        const key2c: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Dau4C",
            socuoc: ketqua.sodaydu.substring(start2C, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0,
        };
        await InsertRedis(key2c);
    }
}
// Duoi2C MB,MN
async function Insert_Duoi_2C(ketqua: KetQuaStruct) {
    if (ketqua.sodaydu.length < 2) {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const start2C: number = length - 2;
    const end: number = length;
    if (Giai_Duoi2C_All.includes(ketqua.tengiai)) {
        const key2c: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Duoi2C",
            socuoc: ketqua.sodaydu.substring(start2C, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0,
        };
        await InsertRedis(key2c);
    }
}
// Duoi4C MB,MN, có 1 giải thôi
async function Insert_Duoi_4C(ketqua: KetQuaStruct) {
    if (ketqua.sodaydu.length < 4) {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const start4C: number = length - 4;
    const end: number = length;
    if (Giai_Duoi2C_All.includes(ketqua.tengiai)) {
        const key2c: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Duoi4C",
            socuoc: ketqua.sodaydu.substring(start4C, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0,
        };
        await InsertRedis(key2c);
    }
}
// cac loai lo2,3,4
async function Insert_Lo2_3_4(ketqua: KetQuaStruct) {
    const length = ketqua.sodaydu.length;
    const end = length;

    if (length >= 4) {
        const start = length - 4;
        const key: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Lo4C",
            socuoc: ketqua.sodaydu.substring(start, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0
        };
        await InsertRedis(key);
    }

    if (length >= 3) {
        const start = length - 3;
        const key: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Lo3C",
            socuoc: ketqua.sodaydu.substring(start, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0
        };
        await InsertRedis(key);
    }

    if (length >= 2) {
        const start = length - 2;
        const key: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "Lo2C",
            socuoc: ketqua.sodaydu.substring(start, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0
        };
        await InsertRedis(key);
    }
}
// XC HN,MN
async function Insert_XC(ketqua: KetQuaStruct) {
    const length: number = ketqua.sodaydu.length;
    const end: number = length;
    const start: number = length - 3;

    if (length < 3) {
        return;
    }

    if (ketqua.area === "HN") {
        if (Giai_XC_HN.includes(ketqua.tengiai)) {
            const key: KetQuaKey = {
                area: ketqua.area,
                loaicuoc: "XC",
                socuoc: ketqua.sodaydu.substring(start, end),
                ngay: ketqua.ngay.substring(0, 10),
                sonhay: 0
            };
            await InsertRedis(key);
        }
    } else if (Giai_XC_MN.includes(ketqua.tengiai)) {
        const key: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "XC",
            socuoc: ketqua.sodaydu.substring(start, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0
        };
        await InsertRedis(key);
    }
}
// XCDau HN,MN
async function Insert_XC_Dau(ketqua: KetQuaStruct) {
    const length: number = ketqua.sodaydu.length;
    const end: number = length;
    const start: number = length - 3;

    if (length < 3) {
        return;
    }

    if (ketqua.area === "HN") {
        if (Giai_XC_Dau_HN.includes(ketqua.tengiai)) {
            const key: KetQuaKey = {
                area: ketqua.area,
                loaicuoc: "XcDau",
                socuoc: ketqua.sodaydu.substring(start, end),
                ngay: ketqua.ngay.substring(0, 10),
                sonhay: 0
            };
            await InsertRedis(key);
        }
    } else if (Giai_XC_Dau_MN.includes(ketqua.tengiai)) {
        const key: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "XcDau",
            socuoc: ketqua.sodaydu.substring(start, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0
        };
        await InsertRedis(key);
    }
}
// XCDuoi HN,MN
async function Insert_XC_Duoi(ketqua: KetQuaStruct) {
    const length = ketqua.sodaydu.length;
    const end = length;
    const start = length - 3;

    if (length < 3) {
        return;
    }

    if (ketqua.tengiai === "0.1") {
        const key: KetQuaKey = {
            area: ketqua.area,
            loaicuoc: "XcDuoi",
            socuoc: ketqua.sodaydu.substring(start, end),
            ngay: ketqua.ngay.substring(0, 10),
            sonhay: 0
        };

        await InsertRedis(key);
    }
}

async function insertD_De_3c_a(ketqua: KetQuaStruct) {
    if (ketqua.area !== "HN") {
        return;
    }
    if (ketqua.tengiai !== "0.1") {
        return;
    }
    const length = ketqua.sodaydu.length;
    const end = length;
    const start = length - 2;
    if (length < 2) {
        return;
    }
    const key: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "De",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key);

    // deA
    const startDea = 0;
    const endDea = 2;
    const keyDea: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "DeA",
        socuoc: ketqua.sodaydu.substring(startDea, endDea),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(keyDea);

    // 3c
    if (length < 3) {
        return;
    }
    const start3c = length - 3;
    const end3c = length;
    const key3c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "3c",
        socuoc: ketqua.sodaydu.substring(start3c, end3c),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key3c);

    // 3ca
    const start3ca = 0;
    const end3ca = 3;
    const key3ca: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "3cA",
        socuoc: ketqua.sodaydu.substring(start3ca, end3ca),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key3ca);
}
// lô miên bắc
async function insertD_Lo_LoA(ketqua: KetQuaStruct) {
    if (ketqua.area !== "HN") {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const end: number = length;
    const start: number = length - 2;
    if (length < 2) {
        return;
    }
    const key: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "Lo",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key);
    //
    const startA: number = 0;
    const endA: number = 2;
    const so = ketqua.sodaydu.substring(startA, endA);
    const keyA: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "LoA",
        socuoc: so,
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(keyA);
}

// giải nhất
async function insertD_Giai_1(ketqua: KetQuaStruct) {
    if (ketqua.area !== "HN") {
        return;
    }
    if (ketqua.tengiai !== "1.1") {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    let end: number = length;
    let start: number = length - 2;
    if (length < 2) {
        return;
    }
    const key: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "Giai1",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key);
    //
    start = 0;
    end = 2;
    const keyA: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "Giai1A",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(keyA);
    //3 càng nhất
    // 3cc1
    if (length < 3) {
        return;
    }
    start = length - 3;
    const key3c: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "3c1",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key3c);
    // 3cc1a
    start = 0;
    end = 3;
    const key3ca: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "3c1A",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key3ca);
}
/// giải 2
async function insertD_Giai_2(ketqua: KetQuaStruct) {
    if (ketqua.area !== "HN") {
        return;
    }
    if (ketqua.tengiai !== "2.1") {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const end: number = length;
    const start: number = length - 2;
    if (length < 2) {
        return;
    }
    const key: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "Giai2",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key);
}

async function insertD_Giai_2_1(ketqua: KetQuaStruct) {
    if (ketqua.area !== "HN") {
        return;
    }
    if (ketqua.tengiai !== "2.2") {
        return;
    }
    const length: number = ketqua.sodaydu.length;
    const end: number = length;
    const start: number = length - 2;
    if (length < 2) {
        return;
    }
    const key: KetQuaKey = {
        area: ketqua.area,
        loaicuoc: "Giai3",
        socuoc: ketqua.sodaydu.substring(start, end),
        ngay: ketqua.ngay.substring(0, 10),
        sonhay: 0
    };
    await InsertRedis(key);
}
async function InsertKetQuaToRedis(ketqua: KetQuaStruct[]): Promise<Map<string, KetQuaKey>> {
    // Iterate once and insert all types into Redis
    redis.clear()
    for (const item of ketqua) {
        await Insert_6Lo2C_6Lo3C(item);
        await Insert_7Lo3C(item);
        await Insert_7Lo2C(item);
        await Insert_8Lo2C(item);
        await Insert_Dau_2C(item);
        await Insert_Dau_4C(item);
        await Insert_Duoi_2C(item);
        await Insert_Duoi_4C(item);
        await Insert_Lo2_3_4(item);
        await Insert_XC(item);
        await Insert_XC_Dau(item);
        await Insert_XC_Duoi(item);
        // ket qua MB
        await insertD_De_3c_a(item);
        await insertD_Lo_LoA(item);
        await insertD_Giai_1(item);
        await insertD_Giai_2(item);
        await insertD_Giai_2_1(item);
        await Insert_6Lo2C_6Lo3C_MB(item);
    }
    // tới đây redis chứa kết quả trúng, chỉ việc lưu vào db
    const insertData: KetQuaKey[] = []
    for (let [key, value] of redis) {
        insertData.push(value)
    }
    globalDexieDb.ketQuaTrung.bulkPut(insertData)

    return redis;;
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export async function GetKetQuaFromServer(ngay: string) {
    const payLoad = { ngay: ngay }

    await ReportApi.getKetQua(payLoad).then(async (res) => {
        if (!res.data)
            return;
        const data = res.data
        const dataKq: IKetQua[] = []
        const promise = data.map(async (item: IKetQua) => {
            item.ngay = item.ngay.substring(0, 10)

            dataKq.push(item)
        })
        await Promise.all(promise)
        globalDexieDb.ketQua.bulkPut(dataKq)
    })
    await globalDexieDb.ketQua.where("ngay").equals(ngay).toArray().then(async (res) => {
        await globalDexieDb.ketQuaTrung.clear()
        //tính toán các số trúng của từng loại cược
        const data: KetQuaStruct[] = []
        res.map(item => {
            const kq: KetQuaStruct = item
            data.push(kq)
        })
        await InsertKetQuaToRedis(data)
    })
}

async function GetSoNhayKetQuaTrung(key: KetQuaKey): Promise<number> {
    const found = await globalDexieDb.ketQuaTrung.where("[area+loaicuoc+socuoc+ngay]")
        .equals([key.area, key.loaicuoc, key.socuoc, key.ngay]).first()
    if (found)
        key.sonhay = found.sonhay;
    return key.sonhay;
}
export async function GetSoNhayTrung(soCuocKey: SoCuocKey, ngay: string): Promise<number> {
    //BuildKetQuaIfNeeded(ngay)

    const key: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: soCuocKey.LoaiCuoc, socuoc: soCuocKey.SoCuoc, ngay: ngay, sonhay: 0 };
    if (!CacLoaiDaXien.includes(key.loaicuoc)) {
        return await GetSoNhayKetQuaTrung(key)
    } else {
        // tính thưởng các loại đá chéo: "KQXS:BTRE:Lo2C:15" "KQXS:VT:Lo2C:14"
        if (key.loaicuoc == "DaX") {
            const so1 = soCuocKey.SoCuoc.substring(0, 2);
            const so2 = soCuocKey.SoCuoc.substring(3, 5);
            const key_So1_Dai1: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: "Lo2C", socuoc: so1, ngay: ngay, sonhay: 0 };
            const key_So2_Dai1: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: "Lo2C", socuoc: so2, ngay: ngay, sonhay: 0 };

            const key_So1_Dai2: KetQuaKey = { area: soCuocKey.Area2, loaicuoc: "Lo2C", socuoc: so1, ngay: ngay, sonhay: 0 };
            const key_So2_Dai2: KetQuaKey = { area: soCuocKey.Area2, loaicuoc: "Lo2C", socuoc: so2, ngay: ngay, sonhay: 0 };
            //Không trùng bộ số xiên

            let soNhaySo1Dai1 = "0";
            let soNhaySo1Dai2 = "0";
            let soNhaySo2Dai1 = "0";
            let soNhaySo2Dai2 = "0";
            let soNhayTrung = 0.0;
            //
            let soNhaySoThu_1 = 0;
            let soNhaySoThu_2 = 0;
            let tmpSoNhay = 0;
            // số nháy trúng số thứ nhất
            soNhaySo1Dai1 = await GetSoNhayKetQuaTrung(key_So1_Dai1) + ""
            soNhaySo1Dai2 = await GetSoNhayKetQuaTrung(key_So1_Dai2) + ""
            tmpSoNhay = parseInt(soNhaySo1Dai1);
            soNhaySoThu_1 += tmpSoNhay;
            tmpSoNhay = parseInt(soNhaySo1Dai2);
            soNhaySoThu_1 += tmpSoNhay;
            // số nháy trúng số thứ 2
            soNhaySo2Dai1 = await GetSoNhayKetQuaTrung(key_So2_Dai1) + ""
            soNhaySo2Dai2 = await GetSoNhayKetQuaTrung(key_So2_Dai2) + ""
            tmpSoNhay = parseInt(soNhaySo2Dai1);
            soNhaySoThu_2 += tmpSoNhay;
            tmpSoNhay = parseInt(soNhaySo2Dai2);
            soNhaySoThu_2 += tmpSoNhay;
            if (so1 == so2) {
                soNhaySoThu_1 -= 1; // giảm đi 1, vì nếu số thứ nhất trúng rồi, thì số thứ 2 muốn trúng phải có thêm 1 nháy nữa
                soNhaySoThu_2 = 1;  // do trừ số nháy số thứ nhất đi 1, cho vào số nhay số thứ 2
            }
            if (soNhaySoThu_1 > 0 && soNhaySoThu_2 > 0) {
                soNhayTrung = 1; // trúng 1 nháy cái đã
            }

            if (soNhayTrung > 0) {
                // đã xiên nhiều ki
                let tmp = 0.0;
                if (soCuocKey.MN_TinhThuongDaXien_2 == 1) {
                    soNhayTrung = Math.min(soNhaySoThu_1, soNhaySoThu_2);
                }
                // đá xiên thưởng 0.5 ki
                if (soCuocKey.MN_TinhThuongDaXien_05 == 1) {
                    const soNhayTrungThem = soNhaySoThu_1 + soNhaySoThu_2 - Math.min(soNhaySoThu_1, soNhaySoThu_2) * 2
                    if (soNhayTrungThem % 2 > 0) {
                        tmp = 0.5;
                    }
                }
                if (soCuocKey.MN_TinhThuongDaXien_05_NhieuLan == 1) {
                    const soNhayTrungThem = soNhaySoThu_1 + soNhaySoThu_2 - Math.min(soNhaySoThu_1, soNhaySoThu_2) * 2;
                    if (soNhayTrungThem > 0) {
                        tmp = soNhayTrungThem / 2;
                    }
                }
                soNhayTrung += tmp;
                // nếu tính thưởng nhiều ki kiểu củ chuối, ví dụ đá 01,02
                // con 01 có 1 nháy, con 02 có 5 nháy, làm sau, sẽ tính là
                // trúng 1 nháy trước
                // con 02 4 nháy, 4/2=2 nháy nữa kết quả là trúng 3 nháy
            }
            //
            return soNhayTrung;
        } else if (key.loaicuoc == "DaT" || key.loaicuoc == "Xi2") {
            const so1 = soCuocKey.SoCuoc.substring(0, 2);
            const so2 = soCuocKey.SoCuoc.substring(3, 5);
            const key_So1_Dai1: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: "Lo2C", socuoc: so1, ngay: ngay, sonhay: 0 };
            const key_So2_Dai1: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: "Lo2C", socuoc: so2, ngay: ngay, sonhay: 0 };

            let soNhaySo1Dai1 = "0";

            let soNhaySo2Dai1 = "0";

            let soNhayTrung = 0.0;
            //
            let soNhaySoThu_1 = 0;
            let soNhaySoThu_2 = 0;
            let tmpSoNhay = 0;
            // số nháy trúng số thứ nhất
            soNhaySo1Dai1 = await GetSoNhayKetQuaTrung(key_So1_Dai1) + ""

            tmpSoNhay = parseInt(soNhaySo1Dai1);
            soNhaySoThu_1 += tmpSoNhay;

            // số nháy trúng số thứ 2
            soNhaySo2Dai1 = await GetSoNhayKetQuaTrung(key_So2_Dai1) + ""

            tmpSoNhay = parseInt(soNhaySo2Dai1);

            soNhaySoThu_2 += tmpSoNhay;
            if (so1 == so2) {
                soNhaySoThu_1 -= 1; // giảm đi 1, vì nếu số thứ nhất trúng rồi, thì số thứ 2 muốn trúng phải có thêm 1 nháy nữa
                soNhaySoThu_2 = 1;  // do trừ số nháy số thứ nhất đi 1, cho vào số nhay số thứ 2
            }
            if (soNhaySoThu_1 > 0 && soNhaySoThu_2 > 0) {
                soNhayTrung = 1; // trúng 1 nháy cái đã
            }

            if (soNhayTrung > 0) {
                // đá thẳng MB  thưởng nhiều ki
                if (soCuocKey.Area1 == "HN" && soCuocKey.MB_TinhThuongDaThang_2 == 1) {
                    soNhayTrung = Math.min(soNhaySoThu_1, soNhaySoThu_2);
                }
                //đá thẳng miền nam thưởng nhiều ki
                if (soCuocKey.Area1 != "HN" && soCuocKey.MN_TinhThuongDaThang_2 == 1) {
                    soNhayTrung = Math.min(soNhaySoThu_1, soNhaySoThu_2);
                }
                if (soCuocKey.Area1 == "HN") {
                    let tmp = 0.0;
                    // đá thẳng MB thưởng 0.5 ki
                    if (soCuocKey.MB_TinhThuongDaThang_05 == 1) {
                        const soNhayTrungThem = soNhaySoThu_1 + soNhaySoThu_2 - 2;
                        if (soNhayTrungThem > 0) {
                            tmp = 0.5;
                        }
                    }
                    // đá thẳng MB thưởng 0.5 ki nhiều lần
                    if (soCuocKey.MB_TinhThuongDaThang_05_NhieuLan == 1) {
                        const soNhayTrungThem = soNhaySoThu_1 + soNhaySoThu_2 - Math.min(soNhaySoThu_1, soNhaySoThu_2) * 2;

                        tmp = soNhayTrungThem / 2;
                    }
                    soNhayTrung += tmp;
                }
                // đá thẳng MN thưởng 0.5 ki

                if (soCuocKey.Area1 != "HN") {
                    let tmp = 0.0;
                    if (soCuocKey.MN_TinhThuongDaThang_05 == 1) {
                        const soNhayTrungThem = soNhaySoThu_1 + soNhaySoThu_2 - Math.min(soNhaySoThu_1, soNhaySoThu_2) * 2;
                        if (soNhayTrungThem > 0) {
                            tmp = 0.5;
                        }
                    }
                    // đá thẳng MN thưởng 0.5 ki nhiều lần
                    if (soCuocKey.MN_TinhThuongDaThang_05_NhieuLan == 1) {
                        const soNhayTrungThem = soNhaySoThu_1 + soNhaySoThu_2 - Math.min(soNhaySoThu_1, soNhaySoThu_2) * 2;

                        tmp = soNhayTrungThem / 2;
                    }
                    soNhayTrung += tmp;
                }
                // nếu tính thưởng nhiều ki kiểu củ chuối, ví dụ đá 01,02
                // con 01 có 1 nháy, con 02 có 5 nháy, làm sau, sẽ tính là
                // trúng 1 nháy trước
                // con 02 4 nháy, 4/2=2 nháy nữa kết quả là trúng 3 nháy
            }
            //
            return soNhayTrung;
        } else if (key.loaicuoc == "Xi3" || key.loaicuoc == "Xi4") {
            const arr = soCuocKey.SoCuoc.split(","); // sở dĩ tách ra, để còn tính trường hợp đánh trùng số vd:xi4 00 00  01 02
            const hash: { [key: string]: number } = {};
            for (const item of arr) {
                const found = hash[item];
                if (found == null) {
                    hash[item] = 1; // con số đầu tiên của bộ số
                } else {
                    hash[item] = found + 1; // số này xuất hiện thêm 1 lần nữa, muốn trúng thì phải ra thêm 1 nháy trong kết quả
                }
            }
            let soNhay = 1;
            for (const key in hash) {
                const value = hash[key];
                const redisKey: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: "Lo2C", socuoc: key, ngay: ngay, sonhay: 0 };
                const foundRedis = await GetSoNhayKetQuaTrung(redisKey) + ""
                if (foundRedis == null) {
                    return 0; // không trúng
                } else {
                    const soNhayTrongKetQua = parseInt(foundRedis);
                    if (soNhayTrongKetQua < value) {
                        return 0; // trượt
                    }
                }
                //kiểm tra tất cả các bộ số đều có trong kết quả, tức là chạy đến đây, tức là trúng
            }
            return soNhay;
        } else if (key.loaicuoc == "Xi2A" || key.loaicuoc == "Xi3A" || key.loaicuoc == "Xi4A") {
            const arr = soCuocKey.SoCuoc.split(","); // sở dĩ tách ra, để còn tính trường hợp đánh trùng số vd:xi4 00 00  01 02
            const hash: { [key: string]: number } = {};
            for (const item of arr) {
                const found = hash[item];
                if (found == null) {
                    hash[item] = 1; // con số đầu tiên của bộ số
                } else {
                    hash[item] = found + 1; // số này xuất hiện thêm 1 lần nữa, muốn trúng thì phải ra thêm 1 nháy trong kết quả
                }
            }
            let soNhay = 1;
            for (const key in hash) {
                const value = hash[key];
                const redisKey: KetQuaKey = { area: soCuocKey.Area1, loaicuoc: "LoA", socuoc: key, ngay: ngay, sonhay: 0 };
                const foundRedis = await GetSoNhayKetQuaTrung(redisKey) + ""
                if (foundRedis == null) {
                    return 0; // không trúng
                } else {
                    const soNhayTrongKetQua = parseInt(foundRedis);
                    if (soNhayTrongKetQua < value) {
                        return 0; // trượt
                    }
                }
                //kiểm tra tất cả các bộ số đều có trong kết quả, tức là chạy đến đây, tức là trúng
            }
            return soNhay;
        }
    }
    return 0;
}
/* export async function TinhTHuong(newRow: IMessageDetail,
    contactId: number, mienCuPhapId: number, tinhdId: string,
    date: string) {
    const config: IContactsConfig =
        await globalDexieDb.contactsConfig.where("")
            .equals([])
            .first() || ContactsConfig()
    // tính thưởng luôn
    const soCuocKey: SoCuocKey = {
        Area1: newRow.daiId1,
        Area2: newRow.daiId2 || "",
        LoaiCuoc: newRow.loaiCuocId,
        SoCuoc: newRow.soCuoc,
        MN_TinhThuongDaXien_05: (config.mnDax05),
        MN_TinhThuongDaXien_2: (config.mnDax2),
        MN_TinhThuongDaThang_05: (config.mnDat05),
        MN_TinhThuongDaThang_2: (config.mnDat2),
        MB_TinhThuongDaThang_05: (config.mbDat05),
        MB_TinhThuongDaThang_2: (config.mbDat2),
        MB_TinhThuongDaThang_05_NhieuLan: (config.mbDat05NhieuLan),
        MN_TinhThuongDaThang_05_NhieuLan: (config.mnDat05NhieuLan),
        MN_TinhThuongDaXien_05_NhieuLan: (config.mnDax05NhieuLan),
    }
    newRow.soNhayTrung = await GetSoNhayTrung(soCuocKey, date)
} */